//ngControllers.controller('', ['this','panel', 'FileUploader', function(this, panel, FileUploader)
import FeatureController from '../FeatureController';
import 'cropperjs/dist/cropper.min.css'
import Cropper from 'cropperjs';

export default class PhotoManagerController extends FeatureController {

    constructor (panel, FileUploader, $state, $scope) {
      super(panel, $state);
      this.scope = $scope;
      let username = $state.params.username ? $state.params.username : this.panel.getUser().screen_name;
      const self = this;
      this.container = $('#the-main-cropper-container');
      this.panel.get('/v1/media/gallery/' + username, (response) => {
          if (self.panel.okay(response)) {
              self.gallery = response.gallery;
          }
      });
    }

    getThumbnail (position) {
      if (this.gallery.thumbnails[position]) {
        return this.gallery.thumbnails[position].image;
      }
      return 'https://dev.api.courtmenow.com/public/2420197-bigthumbnail.jpg';
    }

    clickLoader (id) {
      this.currentImage = id;
      this.editImageIdentity = 'img-edit-identity' + (Math.round(Math.random()*Math.random()*10000)).toString();
      let upload_canvas = $('<div id="upload-image-canvas" style="background-color:#FFFFFF;">');
      let img = $('<img id="' + this.editImageIdentity + '" style="display:block;min-width:100%;"/>');
      this.container.empty();
      upload_canvas.append(img);
      this.container.append(upload_canvas);
      let canvas = $('#upload-image-canvas');
      canvas.height(canvas.width());
      const loader = $('#fileLoader');
      const self = this;
      loader.on('change', (event) => {
        self.loadFile(event);
      });
      loader.click();
    }

    loadFile (event) {
      let image = document.getElementById(this.editImageIdentity);
      let reader = new FileReader();
      const self = this;
      reader.onload = () => {
        image.src = reader.result;
        self.cropper = new Cropper(image, {
          aspectRatio: 1,
          viewMode: 3,
          ready(event) {
            console.log(event);
          }
        });
        //self.cropper.ready = true;
      };
      this.currentFileName = event.target.files[0].name;
      reader.readAsDataURL(event.target.files[0]);
    }

    savePhoto () {
      if (this.cropper) {
        console.log(this.cropper.getCroppedCanvas());
        this.cropper.getCroppedCanvas().toBlob((blob) => {
          const formData = new FormData();

          formData.append('file', blob, this.currentFileName);
          formData.append('index', this.currentImage);

          const self = this;
          let headers = this.panel.getRequestHeaders();
          headers['Content-Type'] = undefined;
          $.ajax({
            url: this.panel.getBaseUrl()+'/v1/upload/photo',
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            headers,
            success (response) {
              self.container.hide();
              response = (typeof response === 'string') ? JSON.parse(response) : response;
              self.gallery.thumbnails[self.currentImage] = response.item.thumbnails[self.currentImage];
              self.gallery.images[self.currentImage] = response.item.images[self.currentImage];
              self.scope.$apply();
            },
            error () {
              console.log('Upload error');
            },
          });
        }/*, 'image/png' */);
      }
    }

    dataURItoBlob (dataURI) {
      // convert base64 to raw binary data held in a string
      // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
      let byteString = atob(dataURI.split(',')[1]);

      // separate out the mime component
      let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

      // write the bytes of the string to an ArrayBuffer
      let ab = new ArrayBuffer(byteString.length);

      // create a view into the buffer
      let ia = new Uint8Array(ab);

      // set the bytes of the buffer to the correct values
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      // write the ArrayBuffer to a blob, and you're done
      return new Blob([ab], {type: mimeString});
    }

    set_view (view){

        $('.nav li a').removeClass('selected'); $('.profile_view').hide();

        if(typeof view == 'undefined'){

            view = location.hash.substring(1);
            view = view.indexOf('#') > -1 ? view.substring(view.indexOf('#')+1) : view;
            view = view.indexOf('-') > -1 ? view.substring(0, view.indexOf('-')) : view;

            if(view.length == 0){view = 'intro';}
        }
        let _vclass  = '.'+view+'-link';
        $(document).ready(()=>{
            $(_vclass).addClass('selected'); $('.'+view).show();
        });
    }

    click_uploader () {
        this.uploader.clearQueue();
        $("#uploader").click();
    }

    init_gallery (){

        if(typeof location.hash != 'undefined'){

            let photo_id = location.hash.substring(1);

            for(i in this.images){

                if(this.images[i]['parent_id'] === photo_id){

                    this.current_photo = this.images[i]; break;
                }
            }
        }
    }

    add_caption (photo){
        let caption = photo.caption == null ? '' : photo.caption;
        this.panel.confirm("<textarea style='width:300px;height:55px;text-align:left;padding:5px;' id='add_caption'>"+caption+"</textarea>", () => {

            let caption = $("#add_caption").val();

            let data = {q:'add_caption', a:{id:photo.parent_id, caption:caption}};

            const self = this;

            this.panel.post('/v1/profile?p=actions', data, (response) => {

                if(self.panel.okay(response)){

                    photo.caption = caption;

                    self.panel.alert("Your caption has been saved.");
                }
            });
        }, "Add Image Caption", {yes:'Add Caption', no:'Cancel'});
    }

    set_profile_photo (photo){

        const self = this;

        this.panel.post('/v1/profile?p=actions', {q:'set_profile_photo', a:{id:photo.id}}, (response) => {

            if(self.panel.okay(response)){

                for(i in self.images){

                    if(self.images[i]['id'] == photo.id){

                        self.images[i]['image_id'] = photo.id;

                        $(".global-profile-photo").attr('src', self.image_url+self.images[i]['name']);
                    }
                    else{

                        self.images[i]['image_id'] = null;
                    }
                }
            }
        })
    }

    delete_photo (photo) {

        const self = this;

        this.panel.post('/v1/profile?p=actions', {q:'delete_photo', a:{photo:angular.toJson(photo)}}, (response) => {

            if(self.panel.okay(response)){

                let i = self.images.indexOf(photo);

                self.images.splice(i, 1);
            }
        });
    };

    is_profile_pic (photo) {

        return photo.image_id != null;
    }

    toggle_view (hide, show) {

        $('.'+hide).addClass('hide');

        $('.'+show).removeClass('hide');
    }

    edit (edit) {
        $('.profile-popup-edit-'+edit).removeClass('hide');
    }

    popup_close (edit) {
        $('.profile-popup-edit-'+edit).addClass('hide');
    }

    update_profile (){

        let birthday = $("#birthday").val();

        if(birthday != ''){

            let year = new Date().getFullYear();

            let birth_year = parseInt(birthday.substring(0,4));

            if(year - birth_year < 17){

                this.panel.alert("Invalid age. You must be at least +17 years old.");

                return;
            }

            this.profile.birthday = birthday;
        }

        let data = {profile:this.profile};

        const self = this;

        this.panel.post('/v1/update/profile', data, (response) => {

            $('.popup-cancel').click();

            if(self.panel.okay(response)){

                self.panel.alert("Your changes have been saved!");
                window.location = '/profile#intro';
                self.set_view();
            }
        });
    }

    update_match (){

        for(let i in this.match){

            if(this.match[i] != null){

                if(this.match[i].constructor === Array){

                    this.match[i] = this.match[i].join(',');
                }
            }
        }

        let data = {match:this.match};

        const self = this;

        this.panel.post('/v1/update/match', data, (response) => {

            $('.popup-cancel').click();

            if(self.panel.okay(response)){

                self.panel.alert("Your ideal match has been saved!");
                window.location = '/profile#match';
                self.set_view();
            }
        });
    }


    update_settings () {

    };

    init_uploader(FileUploader) {
      const self = this;

      this.uploader = new FileUploader({
        autoUpload: false,
        url: self.panel.getBaseUrl()+'/uploader',
        queueLimit: 12,
        removeAfterUpload: true,
        headers: self.panel.getRequestHeaders()
      });

      this.uploader.onAfterAddingFile = function(item) {
        item.croppedImage = '';
        let reader = new FileReader();
        reader.onload = function(event) {
            item.image = event.target.result;
        };
        reader.readAsDataURL(item._file);
        item.formData = new FormData();
      };

      this.uploader.onBeforeUploadItem ((item) => {
        item._file = this.dataURItoBlob(item.croppedImage);
        console.log(item);
      });

      this.uploader.onSuccessItem ((item, response)=>{
        if(self.panel.okay(response)){
          self.images.push(response.image);
        }
      });
    }

    getWidth () {
        return $('#cropping-space').width();
    }
}



// WEBPACK FOOTER //
// ./src/app/features/photo-manager/PhotoManagerController.js